var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 560 560",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 0.1,
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,182.691,322.725)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24282d",
    d: "M156.88,50.582C166.659,66.127,156.88,69.126,156.88,69.126C156.88,69.126,35.025,114.115,35.025,114.115C-0.829,122.468,-17.127,104.37,-17.127,104.37C-17.127,104.37,-159.729,-52.243,-159.729,-52.243C-167.062,-82.174,-145.061,-91.223,-145.061,-91.223C-145.061,-91.223,-0.015,-116.281,-0.015,-116.281C18.727,-116.977,23.616,-107.232,23.616,-107.232C23.616,-107.232,156.88,50.582,156.88,50.582Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,203.342,316.961)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M136.942,55.869C145.501,71.798,136.942,75.603,136.942,75.603C136.942,75.603,31.382,114.118,31.382,114.118C0,122.678,-14.265,104.133,-14.265,104.133C-14.265,104.133,-139.082,-56.346,-139.082,-56.346C-145.501,-87.016,-126.244,-96.288,-126.244,-96.288C-126.244,-96.288,0.713,-121.964,0.713,-121.964C17.117,-122.678,21.397,-112.693,21.397,-112.693C21.397,-112.693,136.942,55.869,136.942,55.869Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,168.264,239.952)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4bb4e6",
    d: "M-47.697,30.325C-47.697,30.325,-74.684,-2.889,-74.684,-2.889C-77.317,-6.13,-75.572,-11.008,-71.482,-11.844C-71.482,-11.844,37.323,-34.1,37.323,-34.1C42.062,-35.069,46.94,-33.26,49.901,-29.435C49.901,-29.435,75.595,3.753,75.595,3.753C77.317,5.977,76.137,9.236,73.391,9.843C73.391,9.843,-36.69,34.163,-36.69,34.163C-40.79,35.069,-45.05,33.584,-47.697,30.325Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,162.478,300.956)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M18.381,-1.317C18.381,-1.317,13.516,-8.614,13.516,-8.614C12.787,-9.707,11.454,-10.227,10.178,-9.919C10.178,-9.919,-16.514,-3.46,-16.514,-3.46C-18.626,-2.948,-19.587,-0.493,-18.382,1.316C-18.382,1.316,-13.516,8.612,-13.516,8.612C-12.788,9.704,-11.454,10.226,-10.178,9.917C-10.178,9.917,16.514,3.457,16.514,3.457C18.626,2.947,19.587,0.491,18.381,-1.317Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "matrix(1,0,0,1,203.845,290.97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M-13.516,8.612C-12.787,9.705,-11.454,10.227,-10.178,9.919C-10.178,9.919,16.514,3.458,16.514,3.458C18.626,2.947,19.586,0.492,18.38,-1.316C18.38,-1.316,13.516,-8.613,13.516,-8.613C12.788,-9.705,11.454,-10.227,10.178,-9.918C10.178,-9.918,-16.514,-3.458,-16.514,-3.458C-18.625,-2.947,-19.587,-0.492,-18.381,1.316C-18.381,1.316,-13.516,8.612,-13.516,8.612Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,245.214,280.985)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M-13.516,8.612C-12.787,9.705,-11.454,10.227,-10.178,9.919C-10.178,9.919,16.514,3.458,16.514,3.458C18.626,2.947,19.586,0.492,18.38,-1.316C18.38,-1.316,13.516,-8.613,13.516,-8.613C12.788,-9.705,11.454,-10.227,10.178,-9.918C10.178,-9.918,-16.514,-3.458,-16.514,-3.458C-18.626,-2.947,-19.587,-0.492,-18.382,1.316C-18.382,1.316,-13.516,8.612,-13.516,8.612Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,175.316,318.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M18.381,-1.317C18.381,-1.317,13.516,-8.613,13.516,-8.613C12.787,-9.706,11.454,-10.227,10.178,-9.919C10.178,-9.919,-16.514,-3.459,-16.514,-3.459C-18.626,-2.948,-19.587,-0.492,-18.382,1.316C-18.382,1.316,-13.516,8.613,-13.516,8.613C-12.788,9.705,-11.454,10.227,-10.178,9.917C-10.178,9.917,16.514,3.458,16.514,3.458C18.626,2.948,19.587,0.492,18.381,-1.317Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,216.684,308.088)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M18.381,-1.316C18.381,-1.316,13.517,-8.612,13.517,-8.612C12.788,-9.705,11.455,-10.226,10.179,-9.918C10.179,-9.918,-16.514,-3.458,-16.514,-3.458C-18.626,-2.947,-19.586,-0.491,-18.381,1.317C-18.381,1.317,-13.516,8.614,-13.516,8.614C-12.788,9.706,-11.455,10.227,-10.179,9.918C-10.179,9.918,16.514,3.458,16.514,3.458C18.626,2.947,19.586,0.493,18.381,-1.316Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10",
    transform: "matrix(1,0,0,1,258.052,298.102)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M-18.381,1.316C-18.381,1.316,-13.516,8.614,-13.516,8.614C-12.788,9.707,-11.455,10.227,-10.178,9.919C-10.178,9.919,16.515,3.46,16.515,3.46C18.626,2.948,19.586,0.493,18.381,-1.316C18.381,-1.316,13.516,-8.612,13.516,-8.612C12.788,-9.704,11.455,-10.226,10.179,-9.917C10.179,-9.917,-16.514,-3.457,-16.514,-3.457C-18.626,-2.947,-19.586,-0.492,-18.381,1.316Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11",
    transform: "matrix(1,0,0,1,188.154,335.191)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M18.381,-1.317C18.381,-1.317,13.516,-8.614,13.516,-8.614C12.787,-9.706,11.454,-10.227,10.178,-9.919C10.178,-9.919,-16.514,-3.46,-16.514,-3.46C-18.626,-2.948,-19.587,-0.492,-18.382,1.316C-18.382,1.316,-13.516,8.613,-13.516,8.613C-12.788,9.704,-11.455,10.226,-10.18,9.917C-10.18,9.917,16.514,3.457,16.514,3.457C18.626,2.947,19.587,0.491,18.381,-1.317Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12",
    transform: "matrix(1,0,0,1,229.522,325.206)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M-13.516,8.613C-12.787,9.705,-11.454,10.227,-10.178,9.919C-10.178,9.919,16.514,3.458,16.514,3.458C18.626,2.947,19.586,0.492,18.38,-1.316C18.38,-1.316,13.516,-8.613,13.516,-8.613C12.788,-9.704,11.454,-10.226,10.178,-9.917C10.178,-9.917,-16.514,-3.458,-16.514,-3.458C-18.625,-2.947,-19.587,-0.492,-18.381,1.316C-18.381,1.316,-13.516,8.613,-13.516,8.613Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13",
    transform: "matrix(1,0,0,1,270.89,315.221)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M-18.381,1.316C-18.381,1.316,-13.516,8.612,-13.516,8.612C-12.788,9.705,-11.455,10.226,-10.178,9.918C-10.178,9.918,16.515,3.458,16.515,3.458C18.626,2.947,19.586,0.491,18.381,-1.317C18.381,-1.317,13.516,-8.614,13.516,-8.614C12.788,-9.705,11.455,-10.227,10.179,-9.918C10.179,-9.918,-16.514,-3.458,-16.514,-3.458C-18.626,-2.947,-19.586,-0.493,-18.381,1.316Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,200.993,352.31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M13.517,-8.613C12.788,-9.706,11.454,-10.226,10.178,-9.918C10.178,-9.918,-16.514,-3.459,-16.514,-3.459C-18.626,-2.948,-19.586,-0.493,-18.38,1.315C-18.38,1.315,-13.516,8.613,-13.516,8.613C-12.788,9.705,-11.454,10.227,-10.178,9.917C-10.178,9.917,16.514,3.458,16.514,3.458C18.625,2.948,19.587,0.491,18.381,-1.316C18.381,-1.316,13.517,-8.613,13.517,-8.613Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,242.36,342.324)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M13.517,-8.613C12.788,-9.706,11.455,-10.227,10.179,-9.918C10.179,-9.918,-16.514,-3.459,-16.514,-3.459C-18.626,-2.948,-19.586,-0.492,-18.38,1.316C-18.38,1.316,-13.516,8.613,-13.516,8.613C-12.788,9.705,-11.455,10.227,-10.178,9.917C-10.178,9.917,16.515,3.458,16.515,3.458C18.626,2.948,19.586,0.491,18.381,-1.316C18.381,-1.316,13.517,-8.613,13.517,-8.613Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,283.729,332.338)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2c2c2b",
    d: "M18.38,-1.316C18.38,-1.316,13.516,-8.613,13.516,-8.613C12.787,-9.706,11.454,-10.227,10.178,-9.918C10.178,-9.918,-16.515,-3.459,-16.515,-3.459C-18.627,-2.948,-19.587,-0.492,-18.382,1.316C-18.382,1.316,-13.517,8.613,-13.517,8.613C-12.789,9.705,-11.455,10.227,-10.179,9.917C-10.179,9.917,16.513,3.458,16.513,3.458C18.626,2.948,19.586,0.492,18.38,-1.316Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,220.963,382.266)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#565353",
    d: "M13.517,-8.614C12.788,-9.707,11.454,-10.227,10.178,-9.919C10.178,-9.919,-16.514,-3.46,-16.514,-3.46C-18.626,-2.949,-19.586,-0.493,-18.38,1.316C-18.38,1.316,-13.516,8.612,-13.516,8.612C-12.788,9.704,-11.454,10.226,-10.178,9.917C-10.178,9.917,16.514,3.458,16.514,3.458C18.625,2.948,19.587,0.491,18.381,-1.316C18.381,-1.316,13.517,-8.614,13.517,-8.614Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,262.331,372.28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#565353",
    d: "M13.517,-8.613C12.788,-9.706,11.455,-10.226,10.179,-9.918C10.179,-9.918,-16.514,-3.459,-16.514,-3.459C-18.626,-2.948,-19.586,-0.493,-18.38,1.315C-18.38,1.315,-13.516,8.613,-13.516,8.613C-12.788,9.705,-11.455,10.227,-10.178,9.917C-10.178,9.917,16.515,3.458,16.515,3.458C18.626,2.948,19.586,0.491,18.381,-1.316C18.381,-1.316,13.517,-8.613,13.517,-8.613Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,303.699,362.295)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#565353",
    d: "M18.381,-1.316C18.381,-1.316,13.516,-8.613,13.516,-8.613C12.788,-9.706,11.455,-10.226,10.178,-9.918C10.178,-9.918,-16.515,-3.46,-16.515,-3.46C-18.626,-2.949,-19.586,-0.493,-18.381,1.315C-18.381,1.315,-13.516,8.612,-13.516,8.612C-12.788,9.704,-11.455,10.226,-10.179,9.916C-10.179,9.916,16.514,3.457,16.514,3.457C18.626,2.947,19.586,0.492,18.381,-1.316Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,166.454,237.927)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4ab4e6",
    d: "M15.851,14.085C15.309,12.605,13.669,11.847,12.191,12.388C8.795,13.632,5.12,13.481,1.84,11.958C0.955,11.548,0.134,11.044,-0.627,10.472C-0.627,10.472,10.055,6.559,10.055,6.559C11.535,6.017,12.294,4.377,11.753,2.898C11.21,1.419,9.571,0.658,8.093,1.201C8.093,1.201,-4.518,5.82,-4.518,5.82C-4.761,5.34,-4.987,4.848,-5.175,4.335C-5.414,3.682,-5.582,3.023,-5.716,2.362C-5.716,2.362,6.834,-2.235,6.834,-2.235C8.313,-2.777,9.073,-4.416,8.531,-5.895C7.989,-7.375,6.351,-8.133,4.871,-7.593C4.871,-7.593,-5.538,-3.78,-5.538,-3.78C-4.44,-7.905,-1.425,-11.455,2.878,-13.031C4.358,-13.573,5.118,-15.212,4.576,-16.691C4.034,-18.172,2.395,-18.93,0.915,-18.389C-6.459,-15.687,-11.177,-8.915,-11.656,-1.539C-11.656,-1.539,-14.153,-0.624,-14.153,-0.624C-15.632,-0.082,-16.393,1.557,-15.851,3.036C-15.427,4.192,-14.335,4.908,-13.172,4.908C-12.846,4.908,-12.514,4.852,-12.191,4.733C-12.191,4.733,-11.13,4.345,-11.13,4.345C-10.966,4.999,-10.77,5.65,-10.533,6.297C-10.345,6.809,-10.128,7.303,-9.901,7.792C-9.901,7.792,-10.932,8.169,-10.932,8.169C-12.411,8.711,-13.171,10.35,-12.629,11.83C-12.206,12.985,-11.113,13.702,-9.95,13.702C-9.624,13.702,-9.293,13.646,-8.969,13.527C-8.969,13.527,-6.66,12.681,-6.66,12.681C-4.965,14.532,-2.905,16.047,-0.561,17.134C2.016,18.33,4.765,18.93,7.523,18.93C9.756,18.93,11.995,18.537,14.154,17.745C15.633,17.204,16.393,15.564,15.851,14.085Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    visibility: "hidden",
    id: "i20"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.005s",
    values: "hidden; visible; visible; visible",
    keyTimes: "0; 0.519999; 0.999999; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,170.533,237.078)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2baf7f",
    d: "M20.158,-4.632C22.716,6.502,15.764,17.6,4.631,20.158C-6.503,22.716,-17.602,15.764,-20.159,4.631C-22.717,-6.503,-15.765,-17.601,-4.632,-20.158C6.502,-22.716,17.6,-15.765,20.158,-4.632Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,169.878,237.686)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2.016,13.177C1.635,13.177,1.255,13.101,0.898,12.948C0.898,12.948,-11.77,7.549,-11.77,7.549C-13.219,6.931,-13.894,5.256,-13.276,3.806C-12.657,2.356,-10.981,1.684,-9.533,2.3C-9.533,2.3,0.51,6.581,0.51,6.581C0.51,6.581,8.027,-11.056,8.027,-11.056C8.645,-12.505,10.32,-13.177,11.77,-12.562C13.22,-11.944,13.894,-10.268,13.276,-8.819C13.276,-8.819,4.641,11.443,4.641,11.443C4.344,12.138,3.783,12.689,3.081,12.971C2.739,13.108,2.378,13.177,2.016,13.177Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "i21"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.43,543.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(3.999)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "3.999; 4.999; -0.001; -15.001; -15.001; -2.001; 1.999; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413334; 0.62; 0.673333; 0.72; 0.78; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1.016)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1.016; 1 1.016; 1 0.886; 1 0.886; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.62; 0.673333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-466.827,-539.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,354.999,316.273)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#24282d",
    fillOpacity: 0.1,
    fillRule: "evenodd",
    d: "M52.229,207.238C52.229,207.238,60.054,228.413,117.368,223.241C174.682,218.068,167.799,203.842,167.799,203.842C167.799,203.842,139.364,107.389,139.364,107.389C134.965,74.081,129.031,37.233,122.042,13.834C114.331,-11.977,96.455,-44.751,81.535,-58.542C73.113,-66.326,50.614,-81.758,30.49,-92.634C30.49,-92.634,16.875,-143.094,16.875,-143.094C18.256,-143.325,19.096,-144.484,18.759,-145.759C18.759,-145.759,12.837,-168.169,12.837,-168.169C12.488,-169.488,11.005,-170.453,9.524,-170.34C9.524,-170.34,8.333,-174.754,8.333,-174.754C8.333,-174.754,8.928,-174.811,8.928,-174.811C10.43,-174.956,11.37,-176.168,11.017,-177.506C11.017,-177.506,5.094,-199.915,5.094,-199.915C4.741,-201.253,3.223,-202.228,1.72,-202.084C1.72,-202.084,0.978,-202.012,0.978,-202.012C0.978,-202.012,-1.713,-211.984,-1.713,-211.984C-4.425,-222.037,-15.881,-229.333,-27.169,-228.197C-27.169,-228.197,-133.832,-217.463,-133.832,-217.463C-145.121,-216.327,-152.138,-207.173,-149.425,-197.119C-149.425,-197.119,-148.332,-193.069,-148.332,-193.069C-148.332,-193.069,-150.079,-192.901,-150.079,-192.901C-151.581,-192.757,-152.521,-191.544,-152.168,-190.207C-152.168,-190.207,-146.245,-167.797,-146.245,-167.797C-145.892,-166.46,-144.373,-165.484,-142.871,-165.629C-142.871,-165.629,-140.978,-165.811,-140.978,-165.811C-140.978,-165.811,-136.781,-150.258,-136.781,-150.258C-149.12,-157.96,-157.517,-162.983,-159.479,-163.541C-168.106,-165.998,-178.514,-160.296,-164.882,-144.824C-158.201,-137.241,-142.726,-126.987,-127.91,-117.378C-127.91,-117.378,-124.588,-105.069,-124.588,-105.069C-131.889,-104.882,-135.318,-90.382,-132.784,-84.04C-129.73,-76.399,-121.715,-72.339,-115.79,-72.46C-115.79,-72.46,-113.583,-64.28,-113.583,-64.28C-130.585,-69.351,-128.416,-58.649,-126.755,-53.396C-125.058,-48.026,-115.392,-40.798,-115.392,-40.798C-115.392,-40.798,-118.668,-40.025,-119.093,-34.219C-119.392,-30.121,-116.403,-19.641,-110.276,-15.382C-106.972,-13.085,-102.407,-10.403,-99.013,-10.282C-99.013,-10.282,-96.428,-0.702,-96.428,-0.702C-93.716,9.351,-82.261,16.647,-70.972,15.511C-70.972,15.511,-65.081,14.918,-65.081,14.918C-55.891,27.531,-36.796,53.034,-15.733,61.987C4.51,70.589,29.936,95.296,42.622,121.863C42.622,121.863,52.229,207.238,52.229,207.238Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,542)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "468 542; 468 542; 468 542",
    keyTimes: "0; 0.793333; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 2.233; -1.767; -16.259; -17; 1.741; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413333; 0.613333; 0.7; 0.793333; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.91; 1 0.91; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.626667; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468,-542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,378.165,317.209)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b38a",
    d: "M153.729,203.047C153.729,203.047,144.99,149.609,144.99,149.609C140.219,108.504,136.936,67.245,134.875,25.916C133.941,7.188,132.529,-10.099,130.44,-23.533C125.798,-53.385,111.673,-91.153,98.199,-106.919C84.725,-122.684,29.26,-165.578,16.492,-158.332C3.724,-151.087,20.562,-130.934,28.157,-123.289C35.752,-115.645,63.879,-98.483,57.557,-88.521C51.236,-78.559,-123.967,-221.547,-134.086,-224.778C-142.562,-227.484,-153.864,-220.683,-141.91,-202.942C-129.956,-185.201,-82.112,-155.161,-76.624,-144.196C-71.136,-133.23,-68.464,-34.562,-61.088,-20.796C-53.713,-7.029,-36.945,24.304,-15.783,34.755C-8.947,38.131,-1.709,43.787,5.224,51.027C24.977,71.656,35.277,99.569,34.451,128.117C34.451,128.117,31.653,196.984,31.653,196.984C31.653,196.984,34.333,227.609,98.334,226.7C162.335,225.791,153.729,203.047,153.729,203.047Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,348.192,156.991)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1e1c",
    d: "M92.041,103.739C92.041,103.739,72.857,-43.817,72.857,-43.817C74.291,-44.109,75.291,-45.47,75.106,-46.945C75.106,-46.945,71.861,-72.876,71.861,-72.876C71.67,-74.403,70.282,-75.499,68.759,-75.342C68.759,-75.342,68.095,-80.449,68.095,-80.449C68.095,-80.449,68.708,-80.526,68.708,-80.526C70.255,-80.72,71.363,-82.144,71.169,-83.692C71.169,-83.692,67.924,-109.623,67.924,-109.623C67.731,-111.17,66.306,-112.278,64.759,-112.084C64.759,-112.084,63.994,-111.989,63.994,-111.989C63.994,-111.989,62.494,-123.526,62.494,-123.526C60.982,-135.158,50.228,-143.438,38.596,-141.926C38.596,-141.926,-71.31,-127.636,-71.31,-127.636C-82.942,-126.124,-91.222,-115.37,-89.709,-103.738C-89.709,-103.738,-89.1,-99.052,-89.1,-99.052C-89.1,-99.052,-90.898,-98.826,-90.898,-98.826C-92.445,-98.633,-93.553,-97.209,-93.359,-95.661C-93.359,-95.661,-90.115,-69.73,-90.115,-69.73C-89.921,-68.183,-88.497,-67.075,-86.949,-67.269C-86.949,-67.269,-85,-67.512,-85,-67.512C-85,-67.512,-60.163,123.527,-60.163,123.527C-58.65,135.159,-47.896,143.438,-36.265,141.927C-36.265,141.927,73.642,127.637,73.642,127.637C85.273,126.125,93.553,115.371,92.041,103.739Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,350.044,156.615)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M80.261,99.68C80.261,99.68,52.105,-116.889,52.105,-116.889C50.977,-125.565,42.955,-131.741,34.279,-130.613C34.279,-130.613,-66.536,-117.507,-66.536,-117.507C-75.213,-116.379,-81.389,-108.357,-80.26,-99.68C-80.26,-99.68,-52.105,116.889,-52.105,116.889C-50.977,125.565,-42.955,131.741,-34.279,130.613C-34.279,130.613,66.537,117.506,66.537,117.506C75.213,116.378,81.389,108.356,80.261,99.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10",
    transform: "matrix(1,0,0,1,332.218,28.066)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#585657",
    d: "M17.392,-0.88C17.392,-0.88,-17.063,3.483,-17.063,3.483C-17.434,3.531,-17.776,3.265,-17.823,2.894C-17.823,2.894,-17.982,1.64,-17.982,1.64C-18.029,1.268,-17.763,0.927,-17.392,0.88C-17.392,0.88,17.062,-3.484,17.062,-3.484C17.434,-3.531,17.776,-3.266,17.823,-2.894C17.823,-2.894,17.981,-1.64,17.981,-1.64C18.029,-1.269,17.763,-0.927,17.392,-0.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11",
    transform: "matrix(1,0,0,1,355.95,25.223)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#585657",
    d: "M2.188,-0.001C2.188,1.207,1.208,2.188,-0.001,2.188C-1.209,2.188,-2.188,1.207,-2.188,-0.001C-2.188,-1.209,-1.209,-2.188,-0.001,-2.188C1.208,-2.188,2.188,-1.209,2.188,-0.001Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12",
    transform: "matrix(1,0,0,1,273.23,175.171)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b38a",
    d: "M4.024,-13.218C4.024,-13.218,9.167,-8.808,11.594,2.048C14.021,12.903,10.131,22.041,4.074,22.321C-1.982,22.6,-9.687,18.015,-11.854,9.157C-14.021,0.299,-5.828,-22.6,4.024,-13.218Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13",
    transform: "matrix(1,0,0,1,277.326,237.826)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b38a",
    d: "M2.276,-30.479C2.276,-30.479,10.989,-23.994,10.819,-7.724C10.714,2.46,4.672,-0.323,4.672,-0.323C4.672,-0.323,15.589,9.427,14.844,23.234C14.101,37.041,4.139,30.719,-1.569,25.875C-7.276,21.032,-9.017,8.91,-8.203,4.142C-7.049,-2.609,-3.62,-3.561,-3.62,-3.561C-3.62,-3.561,-12.56,-11.794,-13.621,-18.003C-14.683,-24.212,-15.588,-37.042,2.276,-30.479Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,466.296,444.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7900",
    d: "M-65.674,-11.956C-65.674,-11.956,-65.416,20.829,-65.416,20.829C-65.383,25.041,-61.937,28.427,-57.725,28.385C-57.725,28.385,60.259,27.223,60.259,27.223C63.315,27.192,65.705,24.577,65.462,21.53C65.462,21.53,61.872,-23.367,61.872,-23.367C61.64,-26.264,59.108,-28.427,56.211,-28.204C56.211,-28.204,-58.627,-19.61,-58.627,-19.61C-62.624,-19.31,-65.705,-15.964,-65.674,-11.956Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,512.434,443.954)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c42c0e",
    d: "M1.97,4.919C1.97,4.919,-1.539,5.07,-1.539,5.07C-3.329,5.148,-4.842,3.759,-4.92,1.969C-4.92,1.969,-5.07,-1.54,-5.07,-1.54C-5.148,-3.33,-3.759,-4.844,-1.969,-4.921C-1.969,-4.921,1.539,-5.071,1.539,-5.071C3.329,-5.148,4.843,-3.761,4.92,-1.971C4.92,-1.971,5.071,1.538,5.071,1.538C5.148,3.328,3.76,4.842,1.97,4.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,489.206,444.955)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c42c0e",
    d: "M1.97,4.919C1.97,4.919,-1.539,5.07,-1.539,5.07C-3.329,5.148,-4.842,3.759,-4.92,1.97C-4.92,1.97,-5.071,-1.539,-5.071,-1.539C-5.148,-3.329,-3.759,-4.843,-1.969,-4.92C-1.969,-4.92,1.539,-5.071,1.539,-5.071C3.329,-5.148,4.843,-3.76,4.92,-1.97C4.92,-1.97,5.071,1.539,5.071,1.539C5.148,3.328,3.76,4.842,1.97,4.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,465.978,445.956)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c42c0e",
    d: "M1.97,4.919C1.97,4.919,-1.539,5.07,-1.539,5.07C-3.329,5.148,-4.842,3.759,-4.919,1.969C-4.919,1.969,-5.072,-1.54,-5.072,-1.54C-5.149,-3.33,-3.76,-4.844,-1.97,-4.921C-1.97,-4.921,1.538,-5.072,1.538,-5.072C3.328,-5.149,4.842,-3.761,4.919,-1.971C4.919,-1.971,5.072,1.538,5.072,1.538C5.149,3.328,3.76,4.842,1.97,4.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,442.749,446.957)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c42c0e",
    d: "M1.97,4.919C1.97,4.919,-1.539,5.07,-1.539,5.07C-3.328,5.148,-4.842,3.76,-4.919,1.97C-4.919,1.97,-5.072,-1.539,-5.072,-1.539C-5.149,-3.329,-3.76,-4.844,-1.97,-4.921C-1.97,-4.921,1.538,-5.072,1.538,-5.072C3.328,-5.149,4.842,-3.76,4.919,-1.97C4.919,-1.97,5.072,1.539,5.072,1.539C5.149,3.329,3.76,4.842,1.97,4.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,419.521,447.959)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c42c0e",
    d: "M1.97,4.919C1.97,4.919,-1.539,5.07,-1.539,5.07C-3.329,5.148,-4.842,3.759,-4.92,1.969C-4.92,1.969,-5.071,-1.54,-5.071,-1.54C-5.148,-3.329,-3.759,-4.843,-1.969,-4.92C-1.969,-4.92,1.539,-5.071,1.539,-5.071C3.329,-5.148,4.843,-3.76,4.92,-1.971C4.92,-1.971,5.071,1.538,5.071,1.538C5.148,3.328,3.76,4.842,1.97,4.919Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 63,
    stroke: "#6e3200",
    fill: "#f4b38a",
    d: ""
  })))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,542)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "468 542; 468 542; 468 542",
    keyTimes: "0; 0.793333; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 2.233; -1.767; -16.259; -17; 1.741; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413333; 0.613333; 0.7; 0.793333; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.91; 1 0.91; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.626667; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468,-542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i24"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5.005s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0; 1; 1",
    keyTimes: "0; 0.22; 0.266667; 0.88; 0.926667; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.159 0 0.733 1; 0.413 0 0.754 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356,162)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "356 162; 356 162; 350 120; 350 120; 356 162; 356 162",
    keyTimes: "0; 0.22; 0.266667; 0.88; 0.926667; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 0.9 0.9; 1 1; 1 1",
    keyTimes: "0; 0.153333; 0.166667; 0.18; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-356,-162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i13",
    transform: "matrix(1,0,0,1,353.216,160.227)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M26.213,35.151C26.213,35.151,-16.622,40.577,-16.622,40.577C-25.705,41.727,-34.001,35.295,-35.151,26.212C-35.151,26.212,-40.576,-16.622,-40.576,-16.622C-41.726,-25.705,-35.295,-34.001,-26.212,-35.151C-26.212,-35.151,16.622,-40.577,16.622,-40.577C25.705,-41.727,34.002,-35.297,35.152,-26.214C35.152,-26.214,40.577,16.622,40.577,16.622C41.727,25.705,35.296,34.001,26.213,35.151Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,352.32,153.096)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddcec7",
    d: "M21.325,-18.689C21.325,-18.689,-25.31,-12.783,-25.31,-12.783C-28.801,-12.341,-31.273,-9.152,-30.831,-5.662C-30.831,-5.662,-28.446,13.168,-28.446,13.168C-28.004,16.659,-24.816,19.131,-21.325,18.688C-21.325,18.688,25.311,12.783,25.311,12.783C28.802,12.341,31.273,9.152,30.831,5.662C30.831,5.662,28.447,-13.168,28.447,-13.168C28.004,-16.659,24.816,-19.131,21.325,-18.689Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,352.641,156.553)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4851c1",
    d: "M18.351,-17.813C18.351,-17.813,-22.211,-12.675,-22.211,-12.675C-25.195,-12.297,-27.309,-9.572,-26.931,-6.588C-26.931,-6.588,-24.439,13.093,-24.439,13.093C-24.061,16.078,-21.335,18.19,-18.35,17.812C-18.35,17.812,22.212,12.675,22.212,12.675C25.197,12.297,27.309,9.572,26.932,6.588C26.932,6.588,24.439,-13.093,24.439,-13.093C24.061,-16.078,21.335,-18.191,18.351,-17.813Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,353.099,160.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2b814",
    d: "M18.351,-17.812C18.351,-17.812,-22.211,-12.675,-22.211,-12.675C-25.195,-12.297,-27.309,-9.572,-26.931,-6.587C-26.931,-6.587,-24.438,13.093,-24.438,13.093C-24.06,16.077,-21.335,18.19,-18.35,17.813C-18.35,17.813,22.212,12.676,22.212,12.676C25.197,12.298,27.31,9.572,26.932,6.587C26.932,6.587,24.439,-13.093,24.439,-13.093C24.061,-16.077,21.336,-18.19,18.351,-17.812Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,353.555,163.765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2eb785",
    d: "M18.351,-17.812C18.351,-17.812,-22.211,-12.675,-22.211,-12.675C-25.196,-12.297,-27.309,-9.571,-26.931,-6.587C-26.931,-6.587,-24.439,13.093,-24.439,13.093C-24.061,16.078,-21.335,18.19,-18.35,17.813C-18.35,17.813,22.212,12.676,22.212,12.676C25.196,12.298,27.309,9.572,26.932,6.587C26.932,6.587,24.439,-13.092,24.439,-13.092C24.061,-16.077,21.335,-18.19,18.351,-17.812Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,354.012,167.371)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef1d54",
    d: "M18.351,-17.813C18.351,-17.813,-22.211,-12.675,-22.211,-12.675C-25.196,-12.297,-27.309,-9.572,-26.931,-6.588C-26.931,-6.588,-24.439,13.093,-24.439,13.093C-24.061,16.078,-21.335,18.19,-18.35,17.812C-18.35,17.812,22.212,12.675,22.212,12.675C25.197,12.297,27.309,9.572,26.932,6.588C26.932,6.588,24.439,-13.093,24.439,-13.093C24.061,-16.078,21.335,-18.191,18.351,-17.813Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,354.326,169.958)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ddcec7",
    d: "M11.139,-14.457C8.935,-14.178,7.068,-12.647,6.439,-10.518C5.537,-7.462,2.902,-5.075,-0.46,-4.649C-3.822,-4.223,-6.967,-5.879,-8.603,-8.612C-9.742,-10.519,-11.932,-11.535,-14.135,-11.256C-14.135,-11.256,-31.151,-9.101,-31.151,-9.101C-31.151,-9.101,-28.486,11.955,-28.486,11.955C-28.14,14.68,-25.652,16.61,-22.926,16.265C-22.926,16.265,26.496,10.006,26.496,10.006C29.221,9.661,31.152,7.171,30.806,4.446C30.806,4.446,28.139,-16.61,28.139,-16.61C28.139,-16.61,11.139,-14.457,11.139,-14.457Z"
  })))))))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,542)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "468 542; 468 542; 468 542",
    keyTimes: "0; 0.793333; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 2.233; -1.767; -16.259; -17; 1.741; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413333; 0.613333; 0.7; 0.793333; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.91; 1 0.91; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.626667; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468,-542)"
  }, /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    id: "i25"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.005s",
    values: "hidden; visible; visible; visible",
    keyTimes: "0; 0.267; 0.999999; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356,200)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1; 0 0; 0 0",
    keyTimes: "0; 0.266667; 0.3; 0.833333; 0.866667; 1",
    keySplines: "0 0 1 1; 1 0 0.878 1; 0 0 1 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-356,-200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,347.089,128.266)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a4a",
    d: "M47.341,67.091C47.341,67.091,-29.121,76.775,-29.121,76.775C-33.598,77.342,-37.687,74.172,-38.254,69.695C-38.254,69.695,-54.42,-57.958,-54.42,-57.958C-54.987,-62.434,-51.817,-66.524,-47.34,-67.091C-47.34,-67.091,29.122,-76.773,29.122,-76.773C33.599,-77.341,37.688,-74.171,38.255,-69.694C38.255,-69.694,54.421,57.96,54.421,57.96C54.987,62.436,51.818,66.524,47.341,67.091Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,370.176,182.158)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M4.226,-0.524C3.878,-3.274,4.794,-5.889,6.514,-7.799C4.749,-8.97,2.577,-9.543,0.312,-9.256C-4.704,-8.621,-8.255,-4.04,-7.62,0.976C-6.984,5.992,-2.403,9.542,2.612,8.907C4.877,8.621,6.838,7.524,8.255,5.951C6.113,4.53,4.574,2.226,4.226,-0.524Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,384.945,180.31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M-2.611,-8.908C-4.877,-8.621,-6.838,-7.525,-8.255,-5.951C-6.112,-4.531,-4.573,-2.227,-4.225,0.524C-3.877,3.274,-4.793,5.889,-6.513,7.799C-4.749,8.969,-2.576,9.543,-0.311,9.256C4.704,8.621,8.256,4.039,7.62,-0.976C6.985,-5.992,2.405,-9.543,-2.611,-8.908Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,377.561,181.234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#514f51",
    d: "M3.159,-0.4C2.81,-3.15,1.271,-5.454,-0.871,-6.875C-2.591,-4.965,-3.507,-2.35,-3.159,0.4C-2.811,3.15,-1.272,5.454,0.87,6.875C2.591,4.965,3.507,2.35,3.159,-0.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,329.306,186.118)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc6cc",
    d: "M9.447,7.323C9.447,7.323,-7.324,9.447,-7.324,9.447C-7.324,9.447,-9.447,-7.323,-9.447,-7.323C-9.447,-7.323,7.322,-9.447,7.322,-9.447C7.322,-9.447,9.447,7.323,9.447,7.323Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,324.334,182.263)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#898989",
    d: "M9.447,7.323C9.447,7.323,-7.323,9.447,-7.323,9.447C-7.323,9.447,-9.447,-7.323,-9.447,-7.323C-9.447,-7.323,7.323,-9.447,7.323,-9.447C7.323,-9.447,9.447,7.323,9.447,7.323Z"
  })))))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,542)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "468 542; 468 542; 468 542",
    keyTimes: "0; 0.793333; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 2.233; -1.767; -16.259; -17; 1.741; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413333; 0.613333; 0.7; 0.793333; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.91; 1 0.91; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.626667; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468,-542)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,429.328,190.382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.237,20.132C33.763,4.366,-21.702,-38.528,-34.47,-31.283C-47.238,-24.037,-30.4,-3.885,-22.805,3.76C-15.211,11.405,12.917,28.567,6.595,38.528",
    fill: "#f4b38a"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "M47.237,20.132C33.763,4.366,-21.702,-38.528,-34.47,-31.283C-47.238,-24.037,-30.4,-3.885,-22.805,3.76C-15.211,11.405,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-21.702,-38.528,-34.47,-31.283C-47.238,-24.037,-30.4,-3.885,-22.805,3.76C-15.211,11.405,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-17.702,-62.528,-30.47,-55.283C-43.238,-48.037,-24.4,-13.885,-16.805,-6.24C-9.211,1.405,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-13.702,-62.528,-26.47,-55.283C-39.238,-48.037,-20.4,-15.885,-12.805,-8.24C-5.211,-0.595,12.918,28.567,6.596,38.528; M47.237,20.132C33.763,4.366,-17.702,-62.528,-30.47,-55.283C-43.238,-48.037,-24.4,-13.885,-16.805,-6.24C-9.211,1.405,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-41.702,-44.528,-54.47,-37.283C-67.238,-30.037,-50.4,-17.885,-42.805,-10.24C-35.211,-2.595,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-19.702,-54.528,-32.47,-47.283C-45.238,-40.037,-32.4,-25.885,-24.805,-18.24C-17.211,-10.595,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-19.702,-54.528,-32.47,-47.283C-45.238,-40.037,-32.4,-25.885,-24.805,-18.24C-17.211,-10.595,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-21.702,-38.528,-34.47,-31.283C-47.238,-24.037,-30.4,-3.885,-22.805,3.76C-15.211,11.405,12.917,28.567,6.595,38.528; M47.237,20.132C33.763,4.366,-21.702,-38.528,-34.47,-31.283C-47.238,-24.037,-30.4,-3.885,-22.805,3.76C-15.211,11.405,12.917,28.567,6.595,38.528",
    keyTimes: "0; 0.06; 0.1; 0.12; 0.14; 0.153334; 0.186667; 0.52; 0.64; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  })))))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,542)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "468 542; 468 542; 468 542",
    keyTimes: "0; 0.793333; 1",
    keySplines: "0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 2.233; -1.767; -16.259; -17; 1.741; 0; 0",
    keyTimes: "0; 0.093333; 0.313333; 0.413333; 0.613333; 0.7; 0.793333; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 1 0.91; 1 0.91; 1 1; 1 1",
    keyTimes: "0; 0.313333; 0.413333; 0.626667; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468,-542)"
  }, /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    id: "i27"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.005s",
    values: "hidden; visible; hidden; hidden; hidden",
    keyTimes: "0; 0.519999; 0.932999; 0.999999; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(347.003,124.191)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.005s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1.2 1.2; 1 1; 1 1; 0 0; 0 0",
    keyTimes: "0; 0.52; 0.546667; 0.56; 0.846666; 0.873333; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-347.003,-124.191)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "0 100",
    pathLength: 100,
    id: "i18",
    transform: "matrix(1,0,0,1,347.626,125.045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2baf7f",
    d: "M27.564,-4.921C30.282,10.302,20.144,24.846,4.92,27.564C-10.303,30.281,-24.847,20.143,-27.564,4.92C-30.282,-10.303,-20.144,-24.846,-4.92,-27.564C10.303,-30.281,24.847,-20.144,27.564,-4.921Z"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    fill: "freeze",
    begin: "0s",
    dur: "5.005s",
    calcMode: "spline",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    keyTimes: "0; 0.52; 0.56; 1",
    values: "0 100; 0 100; 100 0; 100 0",
    attributeName: "stroke-dasharray"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    fill: "freeze",
    begin: "0s",
    dur: "5.005s",
    calcMode: "spline",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    keyTimes: "0; 0.52; 0.56; 1",
    values: "0; 0; 0; 0",
    attributeName: "stroke-dashoffset"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,349.325,125.318)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#ffffff",
    d: "M13.317,-11.045"
  }, /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.602602496596432s",
    to: "M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.635969195270745s",
    to: "M-10.846,4.935C-12.285,3.933,-13.317,3.213,-13.317,3.213M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.669335893945058s",
    to: "M-4.673,9.238C-7.992,6.924,-13.317,3.213,-13.317,3.213M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.7027025926193717s",
    to: "M1.702,5.618C-0.473,8.74,-2.08,11.045,-2.08,11.045C-2.08,11.045,-13.317,3.213,-13.317,3.213M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.736069291293685s",
    to: "M7.292,-2.401C2.975,3.792,-2.08,11.045,-2.08,11.045C-2.08,11.045,-13.317,3.213,-13.317,3.213M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.769435989967998s",
    to: "M11.595,-8.574C7.576,-2.809,-2.08,11.045,-2.08,11.045C-2.08,11.045,-13.317,3.213,-13.317,3.213M13.317,-11.045",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.033s",
    begin: "2.8028026886423114s",
    to: "M13.317,-11.045C13.317,-11.045,-2.08,11.045,-2.08,11.045C-2.08,11.045,-13.317,3.213,-13.317,3.213",
    attributeName: "d"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.d2ed9664f1ba0a8004e67402fb427bb8.svg";
export { ForwardRef as ReactComponent };